import React, { createContext, useContext } from 'react';

const defaultAppChromeContext = {
  showNotificationsPanel: false,
  onToggleNotifications: () => {},
  onCloseNotifications: () => {},
  onSignIn: () => {},
  discoverPanel: 1,
  administrationPanel: 1,
  setDiscoverPanel: () => {},
  setAdministrationPanel: () => {},
};

const AppChromeContext = createContext(defaultAppChromeContext);

export const useAppChromeContext = () => useContext(AppChromeContext);

export const AppChromeProvider = ({ value, children }) => (
  <AppChromeContext.Provider value={{ ...defaultAppChromeContext, ...value }}>
    {children}
  </AppChromeContext.Provider>
);

export default AppChromeContext;
